import { render } from "./RiskNav.vue?vue&type=template&id=65be7e1c&scoped=true"
import script from "./RiskNav.vue?vue&type=script&lang=js"
export * from "./RiskNav.vue?vue&type=script&lang=js"

import "./RiskNav.vue?vue&type=style&index=0&id=65be7e1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65be7e1c"]])

export default __exports__